import { createSlice, PayloadAction } from "@reduxjs/toolkit"
//UTILS
import currentStorage, {
    clearAuthStorage,
    getStoredAuth,
} from "../../utils/currentStorage"

interface UserSliceState {
    accessToken: string
    user: any
    onboardingSteps: any
    shopPurchased?: any
    profileLoading?: boolean
    retryKycLoading?: boolean
}

const storedAuth = getStoredAuth()

const initialState: UserSliceState = {
    accessToken: storedAuth.accessToken,
    user: storedAuth.user,
    onboardingSteps: null,
    shopPurchased: null,
    profileLoading: false,
    retryKycLoading: false,
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLogin: (state, action: PayloadAction<any>) => {
            const storage = currentStorage()
            sessionStorage.removeItem("accessToken")
            sessionStorage.removeItem("user")
            sessionStorage.removeItem("refreshToken")

            storage.setItem("accessToken", action.payload.accessToken)
            storage.setItem("user", JSON.stringify(action.payload.user))
            return { ...state, ...action.payload }
        },
        setLogout: (state) => {
            clearAuthStorage()
            /* signup page holded data remove if he go back means quit from otp page */
            sessionStorage.removeItem("email")
            sessionStorage.removeItem("username")
            sessionStorage.removeItem("password")
            sessionStorage.removeItem("confirmPassword")
            sessionStorage.removeItem("referralCode")
            sessionStorage.removeItem("acceptTerms")
            return {
                accessToken: "",
                loading: false,
                user: null,
                onboardingSteps: state.onboardingSteps,
            }
        },
        setUpdateUser: (state, action: PayloadAction<{ user: any }>) => {
            const storage = currentStorage()
            storage.setItem("user", JSON.stringify(action.payload.user))
            return {
                ...state,
                user: action.payload.user,
                profileLoading: false,
            }
        },
        //
        setOnboardingSteps: (state, action: PayloadAction<any>) => {
            return { ...state, onboardingSteps: action.payload }
        },
        setShopPurchased: (state, action: PayloadAction<any>) => {
            return { ...state, shopPurchased: action.payload }
        },
        callUserInformation: (state, action: PayloadAction) => {
            return { ...state, profileLoading: true }
        },
        updateLoading: (state, action: PayloadAction<any>) => {
            return { ...state, [action.payload.key]: action.payload.value }
        },
    },
})

export const {
    setLogin,
    setLogout,
    setUpdateUser,
    setOnboardingSteps,
    setShopPurchased,
    callUserInformation,
    updateLoading,
} = userSlice.actions

export const selectUserSlice = (state: { user: UserSliceState }) => state.user
export const selectAccessToken = (state: { user: UserSliceState }) =>
    state.user.accessToken
export const selectUser = (state: { user: UserSliceState }) => state.user.user
export const profileLoading = (state: { user: UserSliceState }) =>
    state.user.profileLoading
export const selectOnboardingSteps = (state: { user: UserSliceState }) =>
    state.user.onboardingSteps
export const selectShopPurchased = (state: { user: UserSliceState }) =>
    state.user.shopPurchased

export default userSlice.reducer
